import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import PageRows from './PageRows';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/i18n/en/app';

export interface IPageRowsSectionProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function PageRowsSection({
  className,
}: React.PropsWithChildren<IPageRowsSectionProps>): React.ReactElement {
  const bem = bemBlock('page-rows-section');
  const { t } = useTranslation();

  return (
    <div className={bem(null, null, className)}>
      <span className={bem('title')}>{t(translationKeys.pagesYouFollow)}</span>
      <PageRows />
    </div>
  );
}
